import Vue from 'vue';
import VueRouter from 'vue-router';
import WecomePage from '@/views/WecomePage.vue';
import ChatPage from '@/views/ChatPage.vue';
import Privacy from "@/views/Privacy.vue";
import BadGateway from '@/views/BadGateway.vue';
import Manual from '@/views/Manual.vue';
import TpcPrivacy from '@/views/TpcPrivacy.vue';
import store from '@/store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'WecomePage',
    component: WecomePage
  },
  {
    path: '/chatPage',
    name: 'ChatPage',
    component: ChatPage
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: Privacy,
  },
  {
    path: "/tpc-privacy",
    name: "TpcPrivacy",
    component: TpcPrivacy,
  },
  {
    path: "/manual",
    name: "Manual",
    component: Manual,
  },
  {
    path: '*', // 匹配所有未定义的路由
    redirect: process.env.NODE_ENV === 'development' ? '/' : '/chat-app/' // 重定向到首页
  },
  {
    path: '/BadGateway',
    component: BadGateway
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.NODE_ENV === 'development' ? '/' : '/chat-app/',
  routes
});

// 添加路由拦截守卫
router.beforeEach((to, from, next) => {
  if (to.path === '/chatPage' && from.path === '/' && store.state.accessType === null) {
    next();
  } else if (to.path === '/chatPage' && store.state.accessType === null) {
    next('/'); // 重定向到首页
  } else {
    next(); // 正常放行
  }
});

export default router;
